Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = require('./color');

var getSvgFont = function getSvgFont(_ref) {
  var fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      letterSpacing = _ref.letterSpacing;
  return {
    fill: _color.textColor,
    stroke: 'none',
    fontFamily: fontFamily,
    fontSize: fontSize,
    letterSpacing: letterSpacing
  };
};

var fontFamily = 'BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif';

exports['default'] = {
  fontFamily: fontFamily,

  // weights
  light: {
    fontWeight: 200
  },
  bold: {
    fontWeight: 700
  },

  // alignment
  start: {
    textAnchor: 'start'
  },
  middle: {
    textAnchor: 'middle'
  },
  end: {
    textAnchor: 'end'
  },

  // size
  tiny: Object.assign({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 10,
    letterSpacing: 0.4
  })),
  small: Object.assign({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 12,
    letterSpacing: 0.4
  })),
  regular: Object.assign({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 14,
    letterSpacing: 0.2
  })),
  large: Object.assign({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 18,
    spacing: 0
  }))
};